import { insertNotesList, isNodeActive, setActiveTool } from "../../../commands/custom-commands";
import { validNotesListTypes, validNotesListValues, customSchema } from "../../../schemas/custom-schema";

export default class NotesListTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--notes-list-anchor";
    this.buttonElement.dataset.action = "notes-list";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Lista de notas";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Lista de notas";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Lista de notas";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--notes-list-anchor";
    this.typeInput = document.createElement("select");
    this.typeInput.className = "editor-dropdown";
    validNotesListTypes.map(({ value, label }) => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = label;

      return option;
    }).forEach(option => this.typeInput.appendChild(option));

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.typeInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const isActive = isNodeActive(view.state, customSchema.nodes.notesList),
      isEnabled = insertNotesList(null)(view.state, null)
    if(isActive) {
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.typeInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: type } = this.typeInput;

      if(!validNotesListTypes.map(attrs => attrs.value).includes(type)) {
        return false;
      }

      insertNotesList(type)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}